/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 4.25.1
 * source: opc.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as pb_1 from "google-protobuf";
export class OptionDetail extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        b?: number;
        a?: number;
        av?: number;
        bv?: number;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("b" in data && data.b != undefined) {
                this.b = data.b;
            }
            if ("a" in data && data.a != undefined) {
                this.a = data.a;
            }
            if ("av" in data && data.av != undefined) {
                this.av = data.av;
            }
            if ("bv" in data && data.bv != undefined) {
                this.bv = data.bv;
            }
        }
    }
    get b() {
        return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
    }
    set b(value: number) {
        pb_1.Message.setField(this, 1, value);
    }
    get a() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
    }
    set a(value: number) {
        pb_1.Message.setField(this, 2, value);
    }
    get av() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
    }
    set av(value: number) {
        pb_1.Message.setField(this, 3, value);
    }
    get bv() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
    }
    set bv(value: number) {
        pb_1.Message.setField(this, 4, value);
    }
    static fromObject(data: {
        b?: number;
        a?: number;
        av?: number;
        bv?: number;
    }): OptionDetail {
        const message = new OptionDetail({});
        if (data.b != null) {
            message.b = data.b;
        }
        if (data.a != null) {
            message.a = data.a;
        }
        if (data.av != null) {
            message.av = data.av;
        }
        if (data.bv != null) {
            message.bv = data.bv;
        }
        return message;
    }
    toObject() {
        const data: {
            b?: number;
            a?: number;
            av?: number;
            bv?: number;
        } = {};
        if (this.b != null) {
            data.b = this.b;
        }
        if (this.a != null) {
            data.a = this.a;
        }
        if (this.av != null) {
            data.av = this.av;
        }
        if (this.bv != null) {
            data.bv = this.bv;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.b != 0)
            writer.writeDouble(1, this.b);
        if (this.a != 0)
            writer.writeDouble(2, this.a);
        if (this.av != 0)
            writer.writeInt32(3, this.av);
        if (this.bv != 0)
            writer.writeInt32(4, this.bv);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): OptionDetail {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new OptionDetail();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.b = reader.readDouble();
                    break;
                case 2:
                    message.a = reader.readDouble();
                    break;
                case 3:
                    message.av = reader.readInt32();
                    break;
                case 4:
                    message.bv = reader.readInt32();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static deserializeBinary(bytes: Uint8Array): OptionDetail {
        return OptionDetail.deserialize(bytes);
    }
}
export class StrikeOptions extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        c?: OptionDetail;
        p?: OptionDetail;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("c" in data && data.c != undefined) {
                this.c = data.c;
            }
            if ("p" in data && data.p != undefined) {
                this.p = data.p;
            }
        }
    }
    get c() {
        return pb_1.Message.getWrapperField(this, OptionDetail, 1) as OptionDetail;
    }
    set c(value: OptionDetail) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get has_c() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get p() {
        return pb_1.Message.getWrapperField(this, OptionDetail, 2) as OptionDetail;
    }
    set p(value: OptionDetail) {
        pb_1.Message.setWrapperField(this, 2, value);
    }
    get has_p() {
        return pb_1.Message.getField(this, 2) != null;
    }
    static fromObject(data: {
        c?: ReturnType<typeof OptionDetail.prototype.toObject>;
        p?: ReturnType<typeof OptionDetail.prototype.toObject>;
    }): StrikeOptions {
        const message = new StrikeOptions({});
        if (data.c != null) {
            message.c = OptionDetail.fromObject(data.c);
        }
        if (data.p != null) {
            message.p = OptionDetail.fromObject(data.p);
        }
        return message;
    }
    toObject() {
        const data: {
            c?: ReturnType<typeof OptionDetail.prototype.toObject>;
            p?: ReturnType<typeof OptionDetail.prototype.toObject>;
        } = {};
        if (this.c != null) {
            data.c = this.c.toObject();
        }
        if (this.p != null) {
            data.p = this.p.toObject();
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.has_c)
            writer.writeMessage(1, this.c, () => this.c.serialize(writer));
        if (this.has_p)
            writer.writeMessage(2, this.p, () => this.p.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): StrikeOptions {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StrikeOptions();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.c, () => message.c = OptionDetail.deserialize(reader));
                    break;
                case 2:
                    reader.readMessage(message.p, () => message.p = OptionDetail.deserialize(reader));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static deserializeBinary(bytes: Uint8Array): StrikeOptions {
        return StrikeOptions.deserialize(bytes);
    }
}
export class ChainEntry extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        e?: string;
        ey?: number;
        em?: number;
        ed?: number;
        c?: Map<string, StrikeOptions>;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("e" in data && data.e != undefined) {
                this.e = data.e;
            }
            if ("ey" in data && data.ey != undefined) {
                this.ey = data.ey;
            }
            if ("em" in data && data.em != undefined) {
                this.em = data.em;
            }
            if ("ed" in data && data.ed != undefined) {
                this.ed = data.ed;
            }
            if ("c" in data && data.c != undefined) {
                this.c = data.c;
            }
        }
        if (!this.c)
            this.c = new Map();
    }
    get e() {
        return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
    }
    set e(value: string) {
        pb_1.Message.setField(this, 1, value);
    }
    get ey() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
    }
    set ey(value: number) {
        pb_1.Message.setField(this, 2, value);
    }
    get em() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
    }
    set em(value: number) {
        pb_1.Message.setField(this, 3, value);
    }
    get ed() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
    }
    set ed(value: number) {
        pb_1.Message.setField(this, 4, value);
    }
    get c() {
        return pb_1.Message.getField(this, 5) as any as Map<string, StrikeOptions>;
    }
    set c(value: Map<string, StrikeOptions>) {
        pb_1.Message.setField(this, 5, value as any);
    }
    static fromObject(data: {
        e?: string;
        ey?: number;
        em?: number;
        ed?: number;
        c?: {
            [key: string]: ReturnType<typeof StrikeOptions.prototype.toObject>;
        };
    }): ChainEntry {
        const message = new ChainEntry({});
        if (data.e != null) {
            message.e = data.e;
        }
        if (data.ey != null) {
            message.ey = data.ey;
        }
        if (data.em != null) {
            message.em = data.em;
        }
        if (data.ed != null) {
            message.ed = data.ed;
        }
        if (typeof data.c == "object") {
            message.c = new Map(Object.entries(data.c).map(([key, value]) => [key, StrikeOptions.fromObject(value)]));
        }
        return message;
    }
    toObject() {
        const data: {
            e?: string;
            ey?: number;
            em?: number;
            ed?: number;
            c?: {
                [key: string]: ReturnType<typeof StrikeOptions.prototype.toObject>;
            };
        } = {};
        if (this.e != null) {
            data.e = this.e;
        }
        if (this.ey != null) {
            data.ey = this.ey;
        }
        if (this.em != null) {
            data.em = this.em;
        }
        if (this.ed != null) {
            data.ed = this.ed;
        }
        if (this.c != null) {
            data.c = (Object.fromEntries)((Array.from)(this.c).map(([key, value]) => [key, value.toObject()]));
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.e.length)
            writer.writeString(1, this.e);
        if (this.ey != 0)
            writer.writeInt32(2, this.ey);
        if (this.em != 0)
            writer.writeInt32(3, this.em);
        if (this.ed != 0)
            writer.writeInt32(4, this.ed);
        for (const [key, value] of this.c) {
            writer.writeMessage(5, this.c, () => {
                writer.writeString(1, key);
                writer.writeMessage(2, value, () => value.serialize(writer));
            });
        }
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ChainEntry {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ChainEntry();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.e = reader.readString();
                    break;
                case 2:
                    message.ey = reader.readInt32();
                    break;
                case 3:
                    message.em = reader.readInt32();
                    break;
                case 4:
                    message.ed = reader.readInt32();
                    break;
                case 5:
                    reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.c as any, reader, reader.readString, () => {
                        let value;
                        reader.readMessage(message, () => value = StrikeOptions.deserialize(reader));
                        return value;
                    }));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static deserializeBinary(bytes: Uint8Array): ChainEntry {
        return ChainEntry.deserialize(bytes);
    }
}
export class TickerChain extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        entries?: ChainEntry[];
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("entries" in data && data.entries != undefined) {
                this.entries = data.entries;
            }
        }
    }
    get entries() {
        return pb_1.Message.getRepeatedWrapperField(this, ChainEntry, 1) as ChainEntry[];
    }
    set entries(value: ChainEntry[]) {
        pb_1.Message.setRepeatedWrapperField(this, 1, value);
    }
    static fromObject(data: {
        entries?: ReturnType<typeof ChainEntry.prototype.toObject>[];
    }): TickerChain {
        const message = new TickerChain({});
        if (data.entries != null) {
            message.entries = data.entries.map(item => ChainEntry.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data: {
            entries?: ReturnType<typeof ChainEntry.prototype.toObject>[];
        } = {};
        if (this.entries != null) {
            data.entries = this.entries.map((item: ChainEntry) => item.toObject());
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.entries.length)
            writer.writeRepeatedMessage(1, this.entries, (item: ChainEntry) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): TickerChain {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new TickerChain();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.entries, () => pb_1.Message.addToRepeatedWrapperField(message, 1, ChainEntry.deserialize(reader), ChainEntry));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static deserializeBinary(bytes: Uint8Array): TickerChain {
        return TickerChain.deserialize(bytes);
    }
}
export class Chain extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        tickerChains?: Map<string, TickerChain>;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("tickerChains" in data && data.tickerChains != undefined) {
                this.tickerChains = data.tickerChains;
            }
        }
        if (!this.tickerChains)
            this.tickerChains = new Map();
    }
    get tickerChains() {
        return pb_1.Message.getField(this, 1) as any as Map<string, TickerChain>;
    }
    set tickerChains(value: Map<string, TickerChain>) {
        pb_1.Message.setField(this, 1, value as any);
    }
    static fromObject(data: {
        tickerChains?: {
            [key: string]: ReturnType<typeof TickerChain.prototype.toObject>;
        };
    }): Chain {
        const message = new Chain({});
        if (typeof data.tickerChains == "object") {
            message.tickerChains = new Map(Object.entries(data.tickerChains).map(([key, value]) => [key, TickerChain.fromObject(value)]));
        }
        return message;
    }
    toObject() {
        const data: {
            tickerChains?: {
                [key: string]: ReturnType<typeof TickerChain.prototype.toObject>;
            };
        } = {};
        if (this.tickerChains != null) {
            data.tickerChains = (Object.fromEntries)((Array.from)(this.tickerChains).map(([key, value]) => [key, value.toObject()]));
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        for (const [key, value] of this.tickerChains) {
            writer.writeMessage(1, this.tickerChains, () => {
                writer.writeString(1, key);
                writer.writeMessage(2, value, () => value.serialize(writer));
            });
        }
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Chain {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Chain();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.tickerChains as any, reader, reader.readString, () => {
                        let value;
                        reader.readMessage(message, () => value = TickerChain.deserialize(reader));
                        return value;
                    }));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static deserializeBinary(bytes: Uint8Array): Chain {
        return Chain.deserialize(bytes);
    }
}
export class StockInfo extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        symbol?: string;
        name?: string;
        price?: number;
        volume?: number;
        avgVolume?: number;
        changePrice?: number;
        changePercentage?: number;
        marketCap?: number;
        dayLow?: number;
        dayHigh?: number;
        yearLow?: number;
        yearHigh?: number;
        priceAvg50?: number;
        priceAvg200?: number;
        open?: number;
        previousClose?: number;
        eps?: number;
        pe?: number;
        earningsAnnouncement?: string;
        sharesOutstanding?: number;
        timestamp?: number;
        exchange?: string;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("symbol" in data && data.symbol != undefined) {
                this.symbol = data.symbol;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("price" in data && data.price != undefined) {
                this.price = data.price;
            }
            if ("volume" in data && data.volume != undefined) {
                this.volume = data.volume;
            }
            if ("avgVolume" in data && data.avgVolume != undefined) {
                this.avgVolume = data.avgVolume;
            }
            if ("changePrice" in data && data.changePrice != undefined) {
                this.changePrice = data.changePrice;
            }
            if ("changePercentage" in data && data.changePercentage != undefined) {
                this.changePercentage = data.changePercentage;
            }
            if ("marketCap" in data && data.marketCap != undefined) {
                this.marketCap = data.marketCap;
            }
            if ("dayLow" in data && data.dayLow != undefined) {
                this.dayLow = data.dayLow;
            }
            if ("dayHigh" in data && data.dayHigh != undefined) {
                this.dayHigh = data.dayHigh;
            }
            if ("yearLow" in data && data.yearLow != undefined) {
                this.yearLow = data.yearLow;
            }
            if ("yearHigh" in data && data.yearHigh != undefined) {
                this.yearHigh = data.yearHigh;
            }
            if ("priceAvg50" in data && data.priceAvg50 != undefined) {
                this.priceAvg50 = data.priceAvg50;
            }
            if ("priceAvg200" in data && data.priceAvg200 != undefined) {
                this.priceAvg200 = data.priceAvg200;
            }
            if ("open" in data && data.open != undefined) {
                this.open = data.open;
            }
            if ("previousClose" in data && data.previousClose != undefined) {
                this.previousClose = data.previousClose;
            }
            if ("eps" in data && data.eps != undefined) {
                this.eps = data.eps;
            }
            if ("pe" in data && data.pe != undefined) {
                this.pe = data.pe;
            }
            if ("earningsAnnouncement" in data && data.earningsAnnouncement != undefined) {
                this.earningsAnnouncement = data.earningsAnnouncement;
            }
            if ("sharesOutstanding" in data && data.sharesOutstanding != undefined) {
                this.sharesOutstanding = data.sharesOutstanding;
            }
            if ("timestamp" in data && data.timestamp != undefined) {
                this.timestamp = data.timestamp;
            }
            if ("exchange" in data && data.exchange != undefined) {
                this.exchange = data.exchange;
            }
        }
    }
    get symbol() {
        return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
    }
    set symbol(value: string) {
        pb_1.Message.setField(this, 1, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
    }
    set name(value: string) {
        pb_1.Message.setField(this, 2, value);
    }
    get price() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
    }
    set price(value: number) {
        pb_1.Message.setField(this, 3, value);
    }
    get volume() {
        return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
    }
    set volume(value: number) {
        pb_1.Message.setField(this, 4, value);
    }
    get avgVolume() {
        return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
    }
    set avgVolume(value: number) {
        pb_1.Message.setField(this, 5, value);
    }
    get changePrice() {
        return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
    }
    set changePrice(value: number) {
        pb_1.Message.setField(this, 6, value);
    }
    get changePercentage() {
        return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
    }
    set changePercentage(value: number) {
        pb_1.Message.setField(this, 7, value);
    }
    get marketCap() {
        return pb_1.Message.getFieldWithDefault(this, 8, 0) as number;
    }
    set marketCap(value: number) {
        pb_1.Message.setField(this, 8, value);
    }
    get dayLow() {
        return pb_1.Message.getFieldWithDefault(this, 9, 0) as number;
    }
    set dayLow(value: number) {
        pb_1.Message.setField(this, 9, value);
    }
    get dayHigh() {
        return pb_1.Message.getFieldWithDefault(this, 10, 0) as number;
    }
    set dayHigh(value: number) {
        pb_1.Message.setField(this, 10, value);
    }
    get yearLow() {
        return pb_1.Message.getFieldWithDefault(this, 11, 0) as number;
    }
    set yearLow(value: number) {
        pb_1.Message.setField(this, 11, value);
    }
    get yearHigh() {
        return pb_1.Message.getFieldWithDefault(this, 12, 0) as number;
    }
    set yearHigh(value: number) {
        pb_1.Message.setField(this, 12, value);
    }
    get priceAvg50() {
        return pb_1.Message.getFieldWithDefault(this, 13, 0) as number;
    }
    set priceAvg50(value: number) {
        pb_1.Message.setField(this, 13, value);
    }
    get priceAvg200() {
        return pb_1.Message.getFieldWithDefault(this, 14, 0) as number;
    }
    set priceAvg200(value: number) {
        pb_1.Message.setField(this, 14, value);
    }
    get open() {
        return pb_1.Message.getFieldWithDefault(this, 15, 0) as number;
    }
    set open(value: number) {
        pb_1.Message.setField(this, 15, value);
    }
    get previousClose() {
        return pb_1.Message.getFieldWithDefault(this, 16, 0) as number;
    }
    set previousClose(value: number) {
        pb_1.Message.setField(this, 16, value);
    }
    get eps() {
        return pb_1.Message.getFieldWithDefault(this, 17, 0) as number;
    }
    set eps(value: number) {
        pb_1.Message.setField(this, 17, value);
    }
    get pe() {
        return pb_1.Message.getFieldWithDefault(this, 18, 0) as number;
    }
    set pe(value: number) {
        pb_1.Message.setField(this, 18, value);
    }
    get earningsAnnouncement() {
        return pb_1.Message.getFieldWithDefault(this, 19, "") as string;
    }
    set earningsAnnouncement(value: string) {
        pb_1.Message.setField(this, 19, value);
    }
    get sharesOutstanding() {
        return pb_1.Message.getFieldWithDefault(this, 20, 0) as number;
    }
    set sharesOutstanding(value: number) {
        pb_1.Message.setField(this, 20, value);
    }
    get timestamp() {
        return pb_1.Message.getFieldWithDefault(this, 21, 0) as number;
    }
    set timestamp(value: number) {
        pb_1.Message.setField(this, 21, value);
    }
    get exchange() {
        return pb_1.Message.getFieldWithDefault(this, 22, "") as string;
    }
    set exchange(value: string) {
        pb_1.Message.setField(this, 22, value);
    }
    static fromObject(data: {
        symbol?: string;
        name?: string;
        price?: number;
        volume?: number;
        avgVolume?: number;
        changePrice?: number;
        changePercentage?: number;
        marketCap?: number;
        dayLow?: number;
        dayHigh?: number;
        yearLow?: number;
        yearHigh?: number;
        priceAvg50?: number;
        priceAvg200?: number;
        open?: number;
        previousClose?: number;
        eps?: number;
        pe?: number;
        earningsAnnouncement?: string;
        sharesOutstanding?: number;
        timestamp?: number;
        exchange?: string;
    }): StockInfo {
        const message = new StockInfo({});
        if (data.symbol != null) {
            message.symbol = data.symbol;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.price != null) {
            message.price = data.price;
        }
        if (data.volume != null) {
            message.volume = data.volume;
        }
        if (data.avgVolume != null) {
            message.avgVolume = data.avgVolume;
        }
        if (data.changePrice != null) {
            message.changePrice = data.changePrice;
        }
        if (data.changePercentage != null) {
            message.changePercentage = data.changePercentage;
        }
        if (data.marketCap != null) {
            message.marketCap = data.marketCap;
        }
        if (data.dayLow != null) {
            message.dayLow = data.dayLow;
        }
        if (data.dayHigh != null) {
            message.dayHigh = data.dayHigh;
        }
        if (data.yearLow != null) {
            message.yearLow = data.yearLow;
        }
        if (data.yearHigh != null) {
            message.yearHigh = data.yearHigh;
        }
        if (data.priceAvg50 != null) {
            message.priceAvg50 = data.priceAvg50;
        }
        if (data.priceAvg200 != null) {
            message.priceAvg200 = data.priceAvg200;
        }
        if (data.open != null) {
            message.open = data.open;
        }
        if (data.previousClose != null) {
            message.previousClose = data.previousClose;
        }
        if (data.eps != null) {
            message.eps = data.eps;
        }
        if (data.pe != null) {
            message.pe = data.pe;
        }
        if (data.earningsAnnouncement != null) {
            message.earningsAnnouncement = data.earningsAnnouncement;
        }
        if (data.sharesOutstanding != null) {
            message.sharesOutstanding = data.sharesOutstanding;
        }
        if (data.timestamp != null) {
            message.timestamp = data.timestamp;
        }
        if (data.exchange != null) {
            message.exchange = data.exchange;
        }
        return message;
    }
    toObject() {
        const data: {
            symbol?: string;
            name?: string;
            price?: number;
            volume?: number;
            avgVolume?: number;
            changePrice?: number;
            changePercentage?: number;
            marketCap?: number;
            dayLow?: number;
            dayHigh?: number;
            yearLow?: number;
            yearHigh?: number;
            priceAvg50?: number;
            priceAvg200?: number;
            open?: number;
            previousClose?: number;
            eps?: number;
            pe?: number;
            earningsAnnouncement?: string;
            sharesOutstanding?: number;
            timestamp?: number;
            exchange?: string;
        } = {};
        if (this.symbol != null) {
            data.symbol = this.symbol;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.price != null) {
            data.price = this.price;
        }
        if (this.volume != null) {
            data.volume = this.volume;
        }
        if (this.avgVolume != null) {
            data.avgVolume = this.avgVolume;
        }
        if (this.changePrice != null) {
            data.changePrice = this.changePrice;
        }
        if (this.changePercentage != null) {
            data.changePercentage = this.changePercentage;
        }
        if (this.marketCap != null) {
            data.marketCap = this.marketCap;
        }
        if (this.dayLow != null) {
            data.dayLow = this.dayLow;
        }
        if (this.dayHigh != null) {
            data.dayHigh = this.dayHigh;
        }
        if (this.yearLow != null) {
            data.yearLow = this.yearLow;
        }
        if (this.yearHigh != null) {
            data.yearHigh = this.yearHigh;
        }
        if (this.priceAvg50 != null) {
            data.priceAvg50 = this.priceAvg50;
        }
        if (this.priceAvg200 != null) {
            data.priceAvg200 = this.priceAvg200;
        }
        if (this.open != null) {
            data.open = this.open;
        }
        if (this.previousClose != null) {
            data.previousClose = this.previousClose;
        }
        if (this.eps != null) {
            data.eps = this.eps;
        }
        if (this.pe != null) {
            data.pe = this.pe;
        }
        if (this.earningsAnnouncement != null) {
            data.earningsAnnouncement = this.earningsAnnouncement;
        }
        if (this.sharesOutstanding != null) {
            data.sharesOutstanding = this.sharesOutstanding;
        }
        if (this.timestamp != null) {
            data.timestamp = this.timestamp;
        }
        if (this.exchange != null) {
            data.exchange = this.exchange;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.symbol.length)
            writer.writeString(1, this.symbol);
        if (this.name.length)
            writer.writeString(2, this.name);
        if (this.price != 0)
            writer.writeDouble(3, this.price);
        if (this.volume != 0)
            writer.writeInt32(4, this.volume);
        if (this.avgVolume != 0)
            writer.writeInt32(5, this.avgVolume);
        if (this.changePrice != 0)
            writer.writeDouble(6, this.changePrice);
        if (this.changePercentage != 0)
            writer.writeDouble(7, this.changePercentage);
        if (this.marketCap != 0)
            writer.writeDouble(8, this.marketCap);
        if (this.dayLow != 0)
            writer.writeDouble(9, this.dayLow);
        if (this.dayHigh != 0)
            writer.writeDouble(10, this.dayHigh);
        if (this.yearLow != 0)
            writer.writeDouble(11, this.yearLow);
        if (this.yearHigh != 0)
            writer.writeDouble(12, this.yearHigh);
        if (this.priceAvg50 != 0)
            writer.writeDouble(13, this.priceAvg50);
        if (this.priceAvg200 != 0)
            writer.writeDouble(14, this.priceAvg200);
        if (this.open != 0)
            writer.writeDouble(15, this.open);
        if (this.previousClose != 0)
            writer.writeDouble(16, this.previousClose);
        if (this.eps != 0)
            writer.writeDouble(17, this.eps);
        if (this.pe != 0)
            writer.writeDouble(18, this.pe);
        if (this.earningsAnnouncement.length)
            writer.writeString(19, this.earningsAnnouncement);
        if (this.sharesOutstanding != 0)
            writer.writeInt64(20, this.sharesOutstanding);
        if (this.timestamp != 0)
            writer.writeInt64(21, this.timestamp);
        if (this.exchange.length)
            writer.writeString(22, this.exchange);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): StockInfo {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StockInfo();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.symbol = reader.readString();
                    break;
                case 2:
                    message.name = reader.readString();
                    break;
                case 3:
                    message.price = reader.readDouble();
                    break;
                case 4:
                    message.volume = reader.readInt32();
                    break;
                case 5:
                    message.avgVolume = reader.readInt32();
                    break;
                case 6:
                    message.changePrice = reader.readDouble();
                    break;
                case 7:
                    message.changePercentage = reader.readDouble();
                    break;
                case 8:
                    message.marketCap = reader.readDouble();
                    break;
                case 9:
                    message.dayLow = reader.readDouble();
                    break;
                case 10:
                    message.dayHigh = reader.readDouble();
                    break;
                case 11:
                    message.yearLow = reader.readDouble();
                    break;
                case 12:
                    message.yearHigh = reader.readDouble();
                    break;
                case 13:
                    message.priceAvg50 = reader.readDouble();
                    break;
                case 14:
                    message.priceAvg200 = reader.readDouble();
                    break;
                case 15:
                    message.open = reader.readDouble();
                    break;
                case 16:
                    message.previousClose = reader.readDouble();
                    break;
                case 17:
                    message.eps = reader.readDouble();
                    break;
                case 18:
                    message.pe = reader.readDouble();
                    break;
                case 19:
                    message.earningsAnnouncement = reader.readString();
                    break;
                case 20:
                    message.sharesOutstanding = reader.readInt64();
                    break;
                case 21:
                    message.timestamp = reader.readInt64();
                    break;
                case 22:
                    message.exchange = reader.readString();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static deserializeBinary(bytes: Uint8Array): StockInfo {
        return StockInfo.deserialize(bytes);
    }
}
export class RiskFreeRates extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        rates?: Map<string, number>;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("rates" in data && data.rates != undefined) {
                this.rates = data.rates;
            }
        }
        if (!this.rates)
            this.rates = new Map();
    }
    get rates() {
        return pb_1.Message.getField(this, 1) as any as Map<string, number>;
    }
    set rates(value: Map<string, number>) {
        pb_1.Message.setField(this, 1, value as any);
    }
    static fromObject(data: {
        rates?: {
            [key: string]: number;
        };
    }): RiskFreeRates {
        const message = new RiskFreeRates({});
        if (typeof data.rates == "object") {
            message.rates = new Map(Object.entries(data.rates));
        }
        return message;
    }
    toObject() {
        const data: {
            rates?: {
                [key: string]: number;
            };
        } = {};
        if (this.rates != null) {
            data.rates = (Object.fromEntries)(this.rates);
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        for (const [key, value] of this.rates) {
            writer.writeMessage(1, this.rates, () => {
                writer.writeString(1, key);
                writer.writeDouble(2, value);
            });
        }
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RiskFreeRates {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RiskFreeRates();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.rates as any, reader, reader.readString, reader.readDouble));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static deserializeBinary(bytes: Uint8Array): RiskFreeRates {
        return RiskFreeRates.deserialize(bytes);
    }
}
export class OptionProfitCalculator extends pb_1.Message {
    #one_of_decls: number[][] = [];
    constructor(data?: any[] | {
        r?: RiskFreeRates;
        c?: Chain;
        s?: StockInfo[];
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [3], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("r" in data && data.r != undefined) {
                this.r = data.r;
            }
            if ("c" in data && data.c != undefined) {
                this.c = data.c;
            }
            if ("s" in data && data.s != undefined) {
                this.s = data.s;
            }
        }
    }
    get r() {
        return pb_1.Message.getWrapperField(this, RiskFreeRates, 1) as RiskFreeRates;
    }
    set r(value: RiskFreeRates) {
        pb_1.Message.setWrapperField(this, 1, value);
    }
    get has_r() {
        return pb_1.Message.getField(this, 1) != null;
    }
    get c() {
        return pb_1.Message.getWrapperField(this, Chain, 2) as Chain;
    }
    set c(value: Chain) {
        pb_1.Message.setWrapperField(this, 2, value);
    }
    get has_c() {
        return pb_1.Message.getField(this, 2) != null;
    }
    get s() {
        return pb_1.Message.getRepeatedWrapperField(this, StockInfo, 3) as StockInfo[];
    }
    set s(value: StockInfo[]) {
        pb_1.Message.setRepeatedWrapperField(this, 3, value);
    }
    static fromObject(data: {
        r?: ReturnType<typeof RiskFreeRates.prototype.toObject>;
        c?: ReturnType<typeof Chain.prototype.toObject>;
        s?: ReturnType<typeof StockInfo.prototype.toObject>[];
    }): OptionProfitCalculator {
        const message = new OptionProfitCalculator({});
        if (data.r != null) {
            message.r = RiskFreeRates.fromObject(data.r);
        }
        if (data.c != null) {
            message.c = Chain.fromObject(data.c);
        }
        if (data.s != null) {
            message.s = data.s.map(item => StockInfo.fromObject(item));
        }
        return message;
    }
    toObject() {
        const data: {
            r?: ReturnType<typeof RiskFreeRates.prototype.toObject>;
            c?: ReturnType<typeof Chain.prototype.toObject>;
            s?: ReturnType<typeof StockInfo.prototype.toObject>[];
        } = {};
        if (this.r != null) {
            data.r = this.r.toObject();
        }
        if (this.c != null) {
            data.c = this.c.toObject();
        }
        if (this.s != null) {
            data.s = this.s.map((item: StockInfo) => item.toObject());
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.has_r)
            writer.writeMessage(1, this.r, () => this.r.serialize(writer));
        if (this.has_c)
            writer.writeMessage(2, this.c, () => this.c.serialize(writer));
        if (this.s.length)
            writer.writeRepeatedMessage(3, this.s, (item: StockInfo) => item.serialize(writer));
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): OptionProfitCalculator {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new OptionProfitCalculator();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    reader.readMessage(message.r, () => message.r = RiskFreeRates.deserialize(reader));
                    break;
                case 2:
                    reader.readMessage(message.c, () => message.c = Chain.deserialize(reader));
                    break;
                case 3:
                    reader.readMessage(message.s, () => pb_1.Message.addToRepeatedWrapperField(message, 3, StockInfo.deserialize(reader), StockInfo));
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static deserializeBinary(bytes: Uint8Array): OptionProfitCalculator {
        return OptionProfitCalculator.deserialize(bytes);
    }
}
